export default __webpack_public_path__ + "static/media/lager_822_hero_1.418d8789.jpg";